<template>
  <div class="userSection">

    <h1 v-if="this.$route.params.areaId == 1">Vocabulary</h1>
    <h1 v-else-if="this.$route.params.areaId == 2">Listening</h1>
    <h1 v-else>Speaking</h1>

    <h2 v-if="user" style="font-weight: normal;">{{ user.name }}</h2>

    <div class="container" v-if="loaded">
      <h3 v-if="unity && unity.length == 0">No hay ninguna unidad creada</h3>
      <div v-for="(item, index) in unity" :key="index">
        <h3>{{ item.name }}</h3>
        <h4 style="color: var(--darker-grey); font-weight: normal;"
          v-if="unity[index].levels && unity[index].levels.length == 0">Esta unidad no tiene ningún nivel</h4>
        <div v-else class="unities">
          <div class="card" v-for="(item2, index) in unity[index].levels" :key="index">
            <p class="card-title">{{ item2.name }}</p>
            <p style="color: green;" v-if="existInFirstList(item2.id)">Completado</p>
            <p style="color: red;" v-else>Incompleto</p>
          </div>
        </div>
      </div>
    </div>

    <div class="container" v-else>
      <img src="../../assets/loading.gif" alt="Loading" style="height: 200px; height: 200px; padding: 10px;">
    </div>

  </div>
</template>

<script>
import router from "@/router";

export default {
  name: "UserSectionThirdView",
  data() {
    return {
      user: {
        name: "",
      },
      unity: [],
      levels: [],
      loaded: false,
    };
  },
  mounted() {
    this.getUnity();
    this.getCompleted();
  },
  methods: {
    async getUnity() {
      try {
        const response = await this.$axios.get(
          "unities/area/" +
          this.$route.params.areaId +
          "/section/" +
          this.$route.params.sectionId
        );
        //console.log("Respuesta del servidor:", response.data);
        this.unity = response.data;
        this.getCompleted();
      } catch (error) {
        //console.error("Error al realizar la solicitud GET:", error);
      }
    },
    async getCompleted() {
      try {
        const response = await this.$axios.get(
          "usersSections/sections/" +
          this.$route.params.userId +
          "/" +
          this.$route.params.sectionId
        );
        this.getUser();
        this.levels = response.data;
      } catch (error) {
        //console.error("Error al realizar la solicitud GET:", error);
      }
    },
    async getUser() {
      try {
        const response = await this.$axios.get(
          "users/" +
          this.$route.params.userId
        );
        //console.log("Respuesta del servidor:", response.data);
        this.user = response.data;
        this.loaded = true;
      } catch (error) {
        //console.error("Error al realizar la solicitud GET:", error);
      }
    },
    existInFirstList(id) {
      return this.levels.some(item => item.levelId === id);
    },
    goToRoute(route) {
      router.push("/see-specific-user/" + this.$route.params.id + "/" + route);
    },
  },
};
</script>

<style scoped>
.userSection {
  flex: 1;
  background-color: var(--not-so-grey);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

p {
  margin: 0;
}

.container {
  width: 70%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 20px;
  padding: 50px 0;
}

.card {
  background-color: #f4f8f7;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  width: 200px;
  height: 200px;
  padding: 10px;
  gap: 10px;
  border-radius: 10px;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  -ms-border-radius: 10px;
  -o-border-radius: 10px;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;
  transition: all ease-out 0.5s;
  -webkit-transition: all ease-out 0.5s;
  -moz-transition: all ease-out 0.5s;
  -ms-transition: all ease-out 0.5s;
  -o-transition: all ease-out 0.5s;
}

.card-title {
  font-size: 20px;
  font-weight: bold;
}

.card-content {
  color: var(--another-grey);
}

.card-content-other {
  font-style: italic;
}

.card-add {
  align-items: center;
  justify-content: center;
}

.unities {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 20px;
}
</style>